import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TicketsService from "./TicketsService";

export const GetAllTicketsMethod = createAsyncThunk(
    "tickets/all", async(data, {getState, rejectWithValue}) => {
        try {
            return await TicketsService.GetAllTicketsMethod(data);
        }catch (error)
        {
            return rejectWithValue(error);
        }
    }
)

export const GetSingleTicketsMethod = createAsyncThunk(
    "tickets/single", async(ticket_id, {getState, rejectWithValue}) => {
        try {
            return await TicketsService.GetSingleTicketsMethod(ticket_id);
        }catch (error)
        {
            return rejectWithValue(error);
        }
    }
)

const TicketsSlice = createSlice({
    name: "tickets",
    initialState: {
        tickets: [],
        ticket: [],
        isSuccess: false,
        isError: false,
        isLoading: false,
        errors: [],
        message: [],
    },
    reducers: {
        ticketsReset: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.isLoading = false;
            state.errors = [];
            state.message = [];
        },
    },
    extraReducers: {
        [GetAllTicketsMethod.pending]: (state) => {
            state.isLoading = true
        },
        [GetAllTicketsMethod.fulfilled]: (state, {payload}) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.tickets = payload;
        },
        [GetAllTicketsMethod.rejected] : (state, {payload}) => {
            state.isLoading = false;
            state.isError = true;
            state.errrors = payload?.response?.data?.errors
            state.message = payload?.response?.data?.message
        },
        [GetSingleTicketsMethod.pending]: (state) => {
            state.isLoading = true
        },
        [GetSingleTicketsMethod.fulfilled]: (state, {payload}) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.ticket = payload;
        },
        [GetSingleTicketsMethod.rejected] : (state, {payload}) => {
            state.isLoading = false;
            state.isError = true;
            state.errrors = payload?.response?.data?.errors
            state.message = payload?.response?.data?.message
        }
    },
});

export const { ticketsReset } = TicketsSlice.actions;
export default TicketsSlice.reducer;
